import { render, staticRenderFns } from "./appVersionsList.vue?vue&type=template&id=018f85f0&scoped=true"
import script from "./appVersionsList.vue?vue&type=script&lang=js"
export * from "./appVersionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018f85f0",
  null
  
)

export default component.exports